import { auth } from "../firebase";
import { QB_FN } from "../config/urls";

/**
 * Call a QB cloud function via fetch with Firebase ID token auth.
 */
export async function qbCall(fnName, body = {}) {
  const token = await auth.currentUser?.getIdToken();
  const res = await fetch(`${QB_FN}/${fnName}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `${fnName} failed`);
  return data;
}

/**
 * Microsoft Graph cloud function helper.
 * GET uses query params, POST uses body.
 */
export async function msCall(fnName, body = {}, method = "POST") {
  const token = await auth.currentUser?.getIdToken();
  const isGet = method === "GET";
  const url = isGet
    ? `${QB_FN}/${fnName}?${new URLSearchParams(body)}`
    : `${QB_FN}/${fnName}`;
  const res = await fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    ...(isGet ? {} : { body: JSON.stringify(body) }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `${fnName} failed`);
  return data;
}
